import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Portfolio from "./pages/Portfolio";
import RegisterIP from "./pages/RegisterIP";
import Search from "./pages/Search";
import Marketplace from "./pages/Marketplace";
import MarketplaceDetail from "./pages/MarketplaceDetail";
import Copilot from "./pages/Copilot";
import Analytics from "./pages/Analytics";
import Vault from "./pages/Vault";
import Contracts from "./pages/Contracts";
import PublicGallery, { PublicGalleryList } from "./pages/PublicGallery";
import { ForgotPassword, MagicConsume } from "./pages/MagicLink";
import DemoAutoLogin from "./pages/DemoAutoLogin";
import GlobalAssistance from "./pages/GlobalAssistance";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/demo" element={<DemoAutoLogin />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/auth/magic/:token" element={<MagicConsume />} />
            <Route path="/gallery" element={<PublicGalleryList />} />
            <Route path="/p/:slug" element={<PublicGallery />} />
            <Route path="/assistance" element={<GlobalAssistance />} />

            {/* Protected app */}
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/register-ip" element={<RegisterIP />} />
              <Route path="/search" element={<Search />} />
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/marketplace/:id" element={<MarketplaceDetail />} />
              <Route path="/copilot" element={<Copilot />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/vault" element={<Vault />} />
              <Route path="/contracts" element={<Contracts />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
